import standaloneChart from './standaloneChart';
import park from './park';

angular
    .module('signalview.chart', ['chartdisplay', 'sfx.ui'])
    .component('standaloneChart', standaloneChart)
    .component('park', park);
